export enum defFields {
  discount = 'discount',
  TOTAL = 'TOTAL',
  GROSSTOTAL = 'GROSSTOTAL',
  PRICE = 'PRICE',
}
export interface LineInterface {
  type: 'row'
  index?: number
  id?: string
  entityId?: number

  date?: string

  description: string
  productType: string
  quantity: number
  unitPrice?: number
  total?: number
  vatPct?: number
  vatRateId?: string
  taxTotal?: number
  netTotal?: number
  grossTotal?: number
  unit: string
  currency?: string
  defField?: defFields
  pricingModel?: defFields
  discount?: number
  totalDiscount?: number
  focused?: boolean
  work?: boolean
  dragOn?: boolean
  redirectUrl?: string
  hasTypedDescription?: boolean
}
export const LineOrder: Array<keyof LineInterface> = [
  'work',
  'description',
  'productType',
  'date',
  'quantity',
  'unit',
  'unitPrice',
  'discount',
  'vatPct',
  'taxTotal',
  'netTotal',
  'grossTotal',
]

export const DeliveryNoteLineOrder: Array<keyof LineInterface> = [
  'work',
  'description',
  'date',
  'quantity',
  'unit',
  'grossTotal',
]

export interface LineInterfaceWithId extends LineInterface {
  id: string
}
